import { FunctionComponent } from 'react'
import styled, { useTheme, css } from 'styled-components'
import { ellipsis } from 'polished'
import { NewstickerVerticalPostProps } from '@widgets/Teaser/toi/types'
import SvgIcon from '@components/SvgIcon'

type StyledNewstickerVerticalPostProps = Pick<
  NewstickerVerticalPostProps,
  'isFirstChild'
>

const StyledNewstickerVerticalPost = styled.div<StyledNewstickerVerticalPostProps>`
  padding-top: ${({ isFirstChild }) => `${isFirstChild ? '0' : '4.5vw'};`};
  width: 100%;
  height: 100%;
  display: flex;
`

const StyledSvgIcon = styled(SvgIcon)`
  padding-right: 3vw;
  padding-top: ${0.9 + (3.73 * 1.28 - 3.73) / 2}vw;
`

const StyledPostDate = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_50 },
      },
    },
  }) => {
    return css`
      padding-top: 0.7vw;
      width: 22.5vw;
      box-sizing: border-box;
      padding-right: 5px;
      color: ${grey_50};
      font-family: ${sourceSansPro};
      font-size: 3.73vw;
      line-height: 1.28;
      text-transform: uppercase;
    `
  }};
`

const StyledPostText = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: { white },
    },
  }) => {
    return css`
      color: ${white};
      font-family: ${sourceSansPro};
      font-weight: bold;
      font-size: 4.3vw;
      line-height: 1.28;
      height: ${2 * 1.28 * 4.3}vw;
      flex: 1;
      box-sizing: border-box;
      ${ellipsis('100%', 2)};
    `
  }};
`

const NewstickerVerticalPost: FunctionComponent<
  NewstickerVerticalPostProps
> = ({ dateInfo, children, isFirstChild }) => {
  const theme = useTheme()
  return (
    <StyledNewstickerVerticalPost isFirstChild={isFirstChild}>
      <StyledSvgIcon
        iconName="newsticker-clock"
        size="3.73vw"
        color={theme.colors.brandColors.brand_55}
      />
      <StyledPostDate
        {...(dateInfo.dateOrTime
          ? { children: dateInfo.dateOrTime }
          : {
              dangerouslySetInnerHTML: {
                __html: '&block;&block;&block;&block;',
              },
            })}
      />
      <StyledPostText>{children}</StyledPostText>
    </StyledNewstickerVerticalPost>
  )
}

export default NewstickerVerticalPost
